import React from "react";

import CommonWorkBenchDrawer
from "./CommonWorkBenchDrawer";


// =============================================================================
// COMPONENT
// =============================================================================

export default function TraceabilityDetailDrawer({

  open,

  row,

  onClose

}) {

  if (!row) {

    return null;
  }


  return (

    <CommonWorkBenchDrawer

      open={open}

      onClose={onClose}

      title={
        `Material Traceability - ${row.material_code}`
      }
    >


      <div style={styles.container}>


        {/* ============================================================ */}
        {/* PROJECT */}
        {/* ============================================================ */}
        <Section title="Project Information">


          <InfoGrid>

            <InfoItem
              label="Project"
              value={row.project_name}
            />

            <InfoItem
              label="Phase"
              value={row.phase_name}
            />

            <InfoItem
              label="Task"
              value={row.task_name}
            />

          </InfoGrid>

        </Section>


        {/* ============================================================ */}
        {/* MATERIAL */}
        {/* ============================================================ */}
        <Section title="Material Information">


          <InfoGrid>

            <InfoItem
              label="Material Code"
              value={row.material_code}
            />

            <InfoItem
              label="Material Name"
              value={row.material_name}
            />

          </InfoGrid>

        </Section>


        {/* ============================================================ */}
        {/* LIFECYCLE */}
        {/* ============================================================ */}
        <Section title="Lifecycle Quantities">


          <InfoGrid>

            <InfoItem
              label="Planned Qty"
              value={row.planned_qty}
            />

            <InfoItem
              label="Reserved Qty"
              value={row.reserved_qty}
            />

            <InfoItem
              label="Dispatched Qty"
              value={row.dispatched_qty}
            />

            <InfoItem
              label="Received Qty"
              value={row.received_qty}
            />

            <InfoItem
              label="Reconciled Qty"
              value={row.reconciled_qty}
            />

          </InfoGrid>

        </Section>


        {/* ============================================================ */}
        {/* PENDING */}
        {/* ============================================================ */}
        <Section title="Pending Quantities">


          <InfoGrid>

            <InfoItem
              label="Pending Dispatch"
              value={
                row.pending_dispatch_qty
              }
            />

            <InfoItem
              label="Pending Receipt"
              value={
                row.pending_receipt_qty
              }
            />

            <InfoItem
              label="Pending Reconciliation"
              value={
                row.pending_reconciliation_qty
              }
            />

          </InfoGrid>

        </Section>


        {/* ============================================================ */}
        {/* STATUS */}
        {/* ============================================================ */}
        <Section title="Lifecycle Status">


          <InfoGrid>

            <InfoItem
              label="Dispatch Status"
              value={row.dispatch_status}
            />

            <InfoItem
              label="Receipt Status"
              value={row.receipt_status}
            />

            <InfoItem
              label="Validation"
              value={row.validation_status}
            />

          </InfoGrid>

        </Section>


        {/* ============================================================ */}
        {/* BOX TRACKING */}
        {/* ============================================================ */}
        <Section title="Box Verification">


          <InfoGrid>

            <InfoItem
              label="Dispatched Boxes"
              value={
                row.dispatched_box_count || 0
              }
            />

            <InfoItem
              label="Received Boxes"
              value={
                row.received_box_count || 0
              }
            />

            <InfoItem
              label="Damaged Boxes"
              value={
                row.damaged_box_count || 0
              }
            />

            <InfoItem
              label="Short Boxes"
              value={
                row.short_box_count || 0
              }
            />

          </InfoGrid>

        </Section>

      </div>

    </CommonWorkBenchDrawer>
  );
}


// =============================================================================
// SECTION
// =============================================================================

function Section({

  title,

  children

}) {

  return (

    <div style={styles.section}>


      <div style={styles.sectionTitle}>

        {title}

      </div>


      {children}

    </div>
  );
}


// =============================================================================
// INFO GRID
// =============================================================================

function InfoGrid({

  children

}) {

  return (

    <div style={styles.infoGrid}>

      {children}

    </div>
  );
}


// =============================================================================
// INFO ITEM
// =============================================================================

function InfoItem({

  label,

  value

}) {

  return (

    <div style={styles.infoItem}>


      <div style={styles.label}>

        {label}

      </div>


      <div style={styles.value}>

        {value || "-"}

      </div>

    </div>
  );
}


// =============================================================================
// STYLES
// =============================================================================

const styles = {

  container: {

    display: "flex",

    flexDirection: "column",

    gap: 20
  },

  section: {

    background: "#ffffff",

    borderRadius: 12,

    padding: 18,

    boxShadow:
      "0 1px 3px rgba(0,0,0,0.06)"
  },

  sectionTitle: {

    fontSize: 15,

    fontWeight: 700,

    marginBottom: 16,

    color: "#111827"
  },

  infoGrid: {

    display: "grid",

    gridTemplateColumns:
      "repeat(auto-fit, minmax(220px, 1fr))",

    gap: 16
  },

  infoItem: {

    display: "flex",

    flexDirection: "column"
  },

  label: {

    fontSize: 12,

    color: "#6b7280",

    marginBottom: 6
  },

  value: {

    fontSize: 15,

    fontWeight: 600,

    color: "#111827"
  }
};